export const CertificateInformationCard = ({
  tenantData,
}: {
  tenantData: any;
}) => {
  const convertToJST = (isoString: string) => {
    if (!isoString) return "未登録";
    const jst = new Intl.DateTimeFormat("ja-JP", {
      timeZone: "Asia/Tokyo",
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false,
    }).format(new Date(isoString));
    return jst;
  };

  return (
    <div className="mt-5 bg-slate-50 p-5 rounded-lg w-3/4">
      <h2 className="mb-6 label-light-blue-xl">現在の証明書</h2>
      <div className="ml-5">
        <div className="flex flex-row gap-2">
          <p className="text-lg font-semibold mb-2">証明書作成者ID:</p>
          <p className="text-lg">
            {tenantData?.active_certificate?.issuer_id || "未登録"}
          </p>
        </div>
        <div className="mt-1 divider" />
        <div>
          <div className="flex flex-row gap-2">
            <p className="text-lg font-semibold mb-2">証明書ファイル名:</p>
            <p className="text-lg">
              {tenantData?.active_certificate?.certificate_name || "未登録"}
            </p>
          </div>
        </div>
        <div className="mt-5 divider" />
        <div className="flex flex-row gap-2">
          <p className="text-lg font-semibold mb-2">有効期限:</p>
          <p className="text-lg">
            {convertToJST(tenantData?.active_certificate?.expires_at)}
          </p>
        </div>
      </div>
    </div>
  );
};
